import { mobileApiGet } from '@/api/mobile/client'
import { ApiError } from '@/api/types'
import { useToast } from '@/shared/hooks'

type ApkResponse = {
  latestVersion: string
  apkUrl: string
}

export const useRedirectToApk = () => {
  const { addToast } = useToast()

  const redirectToApk = async () => {
    try {
      const data = await mobileApiGet<ApkResponse>('update')

      if (data?.apkUrl) {
        window.location.href = data.apkUrl
      } else {
        addToast('Ошибка!', 'Ссылка на apk не найдена', 'error')
      }
    } catch (e) {
      const error = e as ApiError
      addToast('Ошибка!', error.message || 'Не удалось получить apk', 'error')
    }
  }

  return { redirectToApk }
}
